export class ChangePasswordConstant {
  static readonly CHANGE_PASSWORD: string = "Change password for";
  static readonly CURRENT_PASSWORD: string = "Current password";
  static readonly NEW_PASSWORD: string = "New password";
  static readonly CONFIRM_NEW_PASSWORD: string = "Confirm new password";
}
